<template>
  <div class="ex_live_look" catchtouchmove="true" >
    <van-overlay :show="show" >
      <div class="ex_live_look_main">
        <div class="ex_live_look_pop">
          <!-- <div class="look_wrap">
            <p>{{isCode ? '需支付':'请输入邀请码'}}：</p>
            <div class="input_div">
              <input v-model="code" v-if="isCode" class="look_input" maxlength="6" type="number"  />
              <div v-else >{{money}}金豆</div>
            </div>
            <div class="look_qiehuan">
              <span style="color:red;" v-if="codeError">邀请码错误</span>
              <span class="huan" @click="isCode=!isCode;">{{ isCode ? '支付金豆':'我有邀请码'}}</span>
            </div>
          </div> -->
          <div class="look_wrap" v-if="isCode">
            <p>{{'需支付'}}：</p>
            <div class="input_div">
              <!-- <input v-model="code" v-if="isCode" class="look_input" maxlength="6" type="number"  /> -->
              <div >{{money}}金豆</div>
            </div>
            <div class="look_qiehuan">
              <span class="huan" @click="isCode=!isCode;" v-if="isShowCode">{{ '我有邀请码'}}</span>
            </div>
          </div>
          <div class="look_wrap" v-if="isShowCode && !isCode">
            <p>{{'请输入邀请码'}}：</p>
            <div class="input_div">
              <input v-model="code" class="look_input" maxlength="6" type="number"  />
            </div>
            <div class="look_qiehuan">
              <span style="color:red;" v-if="codeError">邀请码错误</span>
              <!-- <span class="huan" @click="isCode=!isCode;">{{ '支付金豆'}}</span> -->
            </div>
          </div>
          <div class="look_btn">
            <span  @click="resetForm">取消</span>
            <span  @click="submit">确定</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import { Dialog } from 'vant';
export default {
  // name: "inquiry",
  props:['isShowPay','isViewLive'],
  data() {
    return {
      show:false,
      isCode:false,
      code:'',
      money:0,
      isShowCode:false,   //是否开启邀请码
      codeError:false,
    }
  },
  computed:{
    ...mapGetters({
      userInfo:'getUserInfo',
      roomId: "getRoomid",
      exhibitionId:'getExhibitionId'
    }),
  },
  watch:{
    isShowPay(old,newVal){
      this.show = old;
      if(old){
        if(this.isViewLive && this.isViewLive.hasOwnProperty('data')){
          this.isShowCode = this.isViewLive.data.hasPassword; // 是否有邀请码
          this.money = this.isViewLive.data.paymentAmount;
        }
      }
    },
  },
  methods:{
    ...mapActions({
      payForMent:'act/payForMent',
      payForPassWord:'act/payForPassWord',
      LinkToMyService:'linkTo/LinkToMyService'
    }),
    async submit(){
      if(!this.isCode){ // 密码观看
        let opt={
          roomId:this.roomId,
          password:this.code
        }
        let res= await this.payForPassWord(opt);
        if(res.result){
          this.$emit('lookOk',1);
        }else{
          this.codeError = true;
        }
        //邀请码
      }else{
        //金豆支付
        let opt={
          roomid:this.roomId,
          memberId:this.userInfo.id
        }
        let res = await this.payForMent(opt);
        if(res.code===1){
          this.$toast.success('支付成功');
          this.$emit('lookOk',1);
        }else if(res.code === 5){
          //余额不足
          Dialog.confirm({
            title: '余额不足',
            message: '您的金豆余额不足了，请前往\n联系客服',
            className:'dialog_yue',
            zIndex:10100,
            confirmButtonText:'前往',
            confirmButtonOpenType:'contact',
          })
          .then(() => { 
            this.LinkToMyService();
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
        }else{
          this.$toast.fail('支付失败');
        }
      }
    },
    resetForm(){
      this.$emit('lookOk',0); //
      this.isCode=true;
      this.code ='';
      this.money = 0;
      this.codeError=false;
    }
  }
};
</script>

<style lang="scss" scoped>
.ex_live_look{
  position: absolute;
  z-index: 10099;
  &_main{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .ex_live_look_pop{
    width: 5.6rem;
    height: 4rem;
    background: #fff;
    border-radius: .1rem;
    position: relative;
    .look_wrap{
      width: 100%;
      height: 3rem;
      padding: .6rem .6rem ;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      p{
        font-size: .26rem;
        color: #999;
      }
      .input_div{
        margin-top: .15rem;
        width: 100%;
        height: .8rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #999;
        border-radius:.1rem ;
        color: #333;
        font-size: .3rem;
        .look_input{
          text-align: center;
          border:none;
        }
      }
      .look_qiehuan{
        margin-top:.2rem;
        display: flex;
        font-size: .26rem;
        .pwd_error{ 
          color:#f94848;
        }
        .huan{
          text-decoration: underline;
          color: #2e9fff;
          margin-left: auto;
        }
      }
    }
    .look_btn{
      width: 100%;
      display: flex;
      position: absolute;
      border-top: 1px solid #d2d3d5;
      left: 0;
      right: 0;
      bottom: 0;
      span,._navigator{
        line-height: 1rem;
        height: 1rem;
        border: none;
        border-radius: 0;
        color: #333;
        font-size: 0.3rem;
        width: 100%;
        text-align: center;
        &:first-child{
          border-right: 1px solid #d2d3d5;
        }
        &:last-child{
          color:#fe5502 ;
          &.des_mit{
            color:#999;
          }
        }
      }
    }
  }
  &::v-deep .yue_dialog{
    .van-popup{
      border-radius: 10px;
      width: 560px;
      box-sizing: border-box;
      .van-dialog__header{
        padding-top: 50px;
        font-size: 36px;
        font-weight: bold;
        color: #333;
      }
      .van-dialog__message{
        font-size: 30px;
        color: #666;
      }
      .van-hairline--top{
        &::after{
          border-color:#d2d3d5;
          border-top-width: 2px;
        }
      }
      .van-dialog__footer{
        .van-hairline--right{
          &::after{
            border-color: #d2d3d5;
            border-right-width: 2px;

          }
        }
        .van-dialog__button{
          .dialog-index--van-dialog__confirm{
            color: #f85b0f!important;
          }
        }
      }
    }
  }
}
</style>
